import AdditionalInfo from './AdditionalInfo';

export default AdditionalInfo;